__turbopack_context__.v({
  "button": "_98ghYa_button",
  "container-grid": "_98ghYa_container-grid",
  "text": "_98ghYa_text",
});
